module.exports = {
        srcSet: __webpack_public_path__ + "static/media/calendar-with-checkmark-664.2eaca062.webp"+" 664w",
        images: [{path: __webpack_public_path__ + "static/media/calendar-with-checkmark-664.2eaca062.webp",width: 664,height: 664}],
        src: __webpack_public_path__ + "static/media/calendar-with-checkmark-664.2eaca062.webp",
        toString: function(){return __webpack_public_path__ + "static/media/calendar-with-checkmark-664.2eaca062.webp"},
        
        width: 664,
        height: 664
      }